import * as z from "@-/com.npmjs.zod";
import { morphemeDefinitionMorphemeSliceSchema } from "#morpheme-definition-morpheme-slice-schema";
import { cardPinyinListEntrySliceSchema } from "#morpheme-pinyin-list-entry-slice-schema";
import { morphemeTierSchema } from "#morpheme-tier";
import { componentButtonMorphemeSliceSchema } from "#component-button-morpheme-slice";
import { graphemeStrokeListSchema } from "#grapheme-stroke-slice";

/**
 * A mnemonics-panel reading: the card pinyin entry plus its syllabus placement, which decides
 * whether a lesson introduces it (`isGraphemeReadingIntroducedAtGrade`). A reading without a
 * pronunciation card is not main and has no level.
 */
export const graphemeMnemonicsPinyinListEntrySliceSchema = cardPinyinListEntrySliceSchema.extend({
  hsk2026Level: z.int().nullable(),
  isMain: z.boolean(),
  tbclLevel: z.int().nullable(),
});

/** Minimum fields to render the card mnemonics panel (meaning tab + decomposition + pronunciation tabs). */
export const graphemeMorphemeMnemonicsPanelMorphemeSliceSchema = z.object({
  back: z.string().optional(),
  components: z.array(componentButtonMorphemeSliceSchema),
  /** Dictionary fallback shown when the user hasn't written a mnemonic yet. */
  definitionList: z.array(morphemeDefinitionMorphemeSliceSchema),
  /** Additional card/component prose authored in study frontmatter. */
  description: z.string().nullable(),
  /** Curated grapheme-file flag marking a leaf/final mnemonic term. */
  final: z.boolean().optional(),
  grapheme: z.string(),
  graphemeId: z.int(),
  graphemeStrokes: graphemeStrokeListSchema,
  isDescriptionPremium: z.boolean(),
  /** Usage/domain tag authored on the meaning card (`mnemonic`, `literary`, etc.). */
  label: z.string().nullish(),
  /** Authored meaning mnemonic rendered in the hero section. */
  mnemonic: z.string().nullable(),
  mnemonicTerms: z.array(z.string()),
  pinyinList: z.array(graphemeMnemonicsPinyinListEntrySliceSchema),
  strokeCount: z.int().nullish(),
  tier: morphemeTierSchema,
});

export type GraphemeMorphemeMnemonicsPanelMorphemeSlice = z.infer<
  typeof graphemeMorphemeMnemonicsPanelMorphemeSliceSchema
>;
